"use strict";

var _interopRequireDefault = require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateGameLevel = exports.getGameLevels = exports.getGameLevelById = exports.deleteGameLevel = exports.defaultGameLevelData = exports.createGameLevel = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
const defaultGameLevelData = exports.defaultGameLevelData = {
  id: 0,
  enabled: true,
  name: null,
  title: null,
  tagLine: null,
  description: null,
  image: null,
  startColour: null,
  endColour: null,
  startValue: 0,
  endValue: 0
};
const getGameLevels = params => (0, _request.default)({
  url: '/game-levels',
  method: 'get',
  params
});
exports.getGameLevels = getGameLevels;
const getGameLevelById = id => (0, _request.default)({
  url: `/game-levels/${id}`,
  method: 'get'
});
exports.getGameLevelById = getGameLevelById;
const updateGameLevel = (id, data) => (0, _request.default)({
  url: `/game-levels/${id}`,
  method: 'patch',
  data
});
exports.updateGameLevel = updateGameLevel;
const deleteGameLevel = id => (0, _request.default)({
  url: `/game-levels/${id}`,
  method: 'delete'
});
exports.deleteGameLevel = deleteGameLevel;
const createGameLevel = data => (0, _request.default)({
  url: '/game-levels/',
  method: 'post',
  data
});
exports.createGameLevel = createGameLevel;